import { render } from "./index.vue?vue&type=template&id=4ebf3fef"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SignUp/AccountExists/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ebf3fef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ebf3fef', __exports__)) {
    console.log('reload')
    api.reload('4ebf3fef', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=4ebf3fef", () => {
    console.log('re-render')
    api.rerender('4ebf3fef', render)
  })

}


export default __exports__